module.exports = {"id":"dp5_4l1q2","text":"Identifying Digital Competence Needs","instructions":"Digital competence includes more than knowing how to use devices and software.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.4","questionType":"PickOne","random":false,"options":[{"id":"dp5_4l1q2-a1","text":"True","score":1.8},{"id":"dp5_4l1q2-a2","text":"Not sure","score":0},{"id":"dp5_4l1q2-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.4/l1q2.json
// module id = 1340
// module chunks = 41